import SkillItem from './skill_item'
import UserExam from './user_exam'
import Answer from "./answer";

export default class Skill {
  readonly id: string
  readonly name: string
  readonly description: string
  readonly createdAt: string
  readonly updatedAt: string

  readonly skillItems: SkillItem[]
  readonly gptAssessments: any[]

  constructor(data: { [key: string]: any }) {
    this.id = data.id
    this.name = data.name
    this.description = data.description
    this.createdAt = data.created_at
    this.updatedAt = data.updated_at

    if (data.skillItems) {
      this.skillItems = data.skillItems.map((element) => new SkillItem(element))
    }

    if (data.gptAssessments) {
      this.gptAssessments = data.gptAssessments
    }
  }

  getSkillScore(userExam: UserExam){
    if (this.skillItems.length == 0) {
      return 0
    }

    let totalScore: number = 0
    let totalAllotment: number = 0

    this.skillItems.forEach((skillItem) => {
      const skillItemAssessments = userExam.assessment.filter(assessment => assessment.skillItemId == skillItem.id)
      skillItemAssessments.forEach(assessment => {
        totalScore += (assessment.score || 0)
        totalAllotment += (assessment.totalAnswerItemsAllotment || 0)
      })
    })


    if (totalAllotment == 0) return 0

    return Math.round(totalScore / totalAllotment * 100 * 10) / 10
  }

  getGptAssessment(answers: Answer[]) {
    return this.gptAssessments.filter((assessment) => {
      return answers.every((answer) => {
        return answers.some((answer) => {
          return answer.id == assessment.aId
        })
      })
    })
  }
}
